export const getLocationText = (locationData) => {
  let string = '';
  if (locationData) {
    switch (locationData.LocationType) {
      default:
        break;
      case 1:
        string = `${locationData.StreetName !== null ? `${locationData.StreetName}, ` : ''}
              ${locationData.HouseNumber !== null ? `${locationData.HouseNumber}, ` : ''}
              ${locationData.CityName !== null ? locationData.CityName : ''}`;
        break;
      case 2:
        string = `${locationData.RegionName !== null ? `${locationData.RegionName}, ` : ''}
              ${locationData.DistrictName !== null ? `${locationData.DistrictName}, ` : ''}
              ${locationData.StreetName !== null ? locationData.StreetName : ''}`;
        break;
      case 3:
        string = `${locationData.RegionName !== null ? `${locationData.RegionName}, ` : ''}
              ${locationData.CityName !== null ? locationData.CityName : ''}`;
        break;
      case 4:
        string = `${locationData.RegionName !== null ? `${locationData.RegionName}, ` : ''}${locationData.DistrictName !== null ? locationData.DistrictName : ''}`;
        break;
    }
  }
  return string;
};



// WEBPACK FOOTER //
// ./src/utils/geo.js